import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Field } from 'formik';
import _ from 'lodash';
import { useLocalize } from '../../../hooks';
import { CheckboxField } from './';
import { Text } from '../';
import { Button } from '../../common/Button';
import { LoadingImage } from '../../common/Loading';
export const UploadFileField = ({ form, field, id, accept, skipFieldId, defaultLabelId, uploading, onUpload, onSkip, renderFile }) => {
    const { values, errors, touched } = form;
    const value = _.get(values, id, []);
    const error = _.get(touched, id) ? _.get(errors, id) : undefined;
    const skipUpload = skipFieldId && _.get(values, skipFieldId, false);
    const { getFieldTranslationId } = useLocalize();
    // using react-dropzone: https://github.com/react-dropzone/react-dropzone
    const { getRootProps, getInputProps } = useDropzone({ onDrop: onUpload, accept, disabled: skipUpload });
    return (React.createElement(React.Fragment, null,
        value && (React.createElement(React.Fragment, null, _.map(value, (f, i) => (React.createElement(React.Fragment, { key: `file${i}` }, renderFile(f, i)))))),
        React.createElement("div", Object.assign({}, getRootProps()),
            React.createElement("input", Object.assign({}, getInputProps())),
            React.createElement("p", null,
                React.createElement(Button, { className: `btn-outline-dark btn-link ${error ? 'invalid' : ''}`, disabled: skipUpload || uploading, onBlur: () => field.onBlur(id) },
                    React.createElement("i", { className: "far fa-paperclip" }),
                    " ",
                    React.createElement(Text, { id: getFieldTranslationId({ id, defaultLabelId }), type: "field" })),
                uploading && (React.createElement(React.Fragment, null,
                    "\u00A0\u00A0 ",
                    React.createElement(LoadingImage, null))))),
        skipFieldId && _.isEmpty(value) && !uploading && (React.createElement("p", null,
            React.createElement(Field, { component: CheckboxField, id: skipFieldId, defaultLabelId: defaultLabelId && `${defaultLabelId}.skip`, onChanged: () => onSkip && onSkip(!skipUpload) })))));
};
//# sourceMappingURL=UploadFile.js.map